import { t } from 'i18n';
function marketFilterDisplayValue(selectedValues, totalValuesCount, {
  allowAll = true
} = {}) {
  if (allowAll && selectedValues.length === totalValuesCount) {
    return t('common.filters.status.allValue');
  }
  if (selectedValues.length === 1) {
    return selectedValues[0];
  }
  if (selectedValues.length === 0) {
    return null;
  }
  return selectedValues.length;
}
export default marketFilterDisplayValue;